export default "__VITE_ASSET__c6dbd674__"